import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './App'
import { ContextProvider } from './context/AppContext'
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom"

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [{
      path: "/:querry",
      element: <App />,
    }],
  },
])

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <ContextProvider>
      <RouterProvider router={router} />
    </ContextProvider>

  </React.StrictMode>
);

